const companyRequiredFields: NodeListOf<HTMLInputElement> = document.querySelectorAll('.required-company');
const vatRequiredFields: NodeListOf<HTMLInputElement> = document.querySelectorAll('.required-vat');
const leitwegRequiredFields: NodeListOf<HTMLInputElement> = document.querySelectorAll('.required-leitweg');
const eInvoiceEmailRequiredFields: NodeListOf<HTMLInputElement> = document.querySelectorAll('.required-einvoiceemail');
let validateBusiness: boolean = false;
let validateVat: boolean = false;
let validateLeitweg: boolean = false;
let validateEInvoiceEmail: boolean = false;

$(() => {
    $('#ProbeAboLandingpageForm').on('submit', function() {
        let isValid = true;
        companyRequiredFields.forEach(field => {
            field.setCustomValidity('');
            if (validateBusiness && field.value == '') {
                field.setCustomValidity('Füllen Sie dieses Feld aus.');
                field.checkValidity();
                field.reportValidity();
                isValid = false;
            }
        });

        vatRequiredFields.forEach(field => {
            field.setCustomValidity('');
            if (validateVat && field.value == '') {
                field.setCustomValidity('Füllen Sie dieses Feld aus.');
                field.checkValidity();
                field.reportValidity();
                isValid = false;
            }
        });

        leitwegRequiredFields.forEach(field => {
            field.setCustomValidity('');
            if (validateLeitweg && field.value == '') {
                field.setCustomValidity('Füllen Sie dieses Feld aus.');
                field.checkValidity();
                field.reportValidity();
                isValid = false;
            }
        });

        eInvoiceEmailRequiredFields.forEach(field => {
            field.setCustomValidity('');
            if (validateEInvoiceEmail && field.value == '') {
                field.setCustomValidity('Füllen Sie dieses Feld aus.');
                field.checkValidity();
                field.reportValidity();
                isValid = false;
            }
        });

        if (!isValid) {
            return false;
        }

        const spinnerModal = $('#spinnerModal');
        spinnerModal.removeClass('hide');

        $(this)
            .find('button[type=submit]')
            .hide();
    });

    $('#ProbeAboLandingpageForm input[type=text]').on('input', function() {
        if ($(this).val() !== '') {
            $(this).addClass('input-green-check');
        } else {
            $(this).removeClass('input-green-check');
        }
    });

    // Blendet eine Row ein/aus, verwaltet das required-Attribut des Pflichtfelds und leert
    // den Wert beim Ausblenden (analog zur Checkout-Toggle-Logik).
    function toggleRow(rowSelector: string, inputSelector: string, show: boolean, mandatory: boolean) {
        var row = $(rowSelector);
        var input = row.find(inputSelector);
        if (show) {
            row.removeClass('hide');
            if (mandatory) {
                input.attr('required', 'required');
            }
        } else {
            row.addClass('hide');
            input.removeAttr('required');
            input.val('');
        }
    }

    function onFormChange() {
        var usageValue = ($('.usage-select')[0] as HTMLSelectElement).value;
        var showVat = $('.CountryListGeschaeftlich')
            .find('option:selected')
            .data('showvat');

        // "geschäftlich" und "öffentlicher Auftraggeber" sind beide geschäftlich (Company + VAT).
        var isBusiness = usageValue === 'business' || usageValue === 'publicauthority';
        var isPublicAuthority = usageValue === 'publicauthority';
        var isGeschaeftlich = usageValue === 'business';

        if (isBusiness) {
            $('#company-fields').removeClass('hide');
            validateBusiness = true;
        } else {
            $('#company-fields').addClass('hide');
            validateBusiness = false;
        }

        if (isBusiness && showVat === 'True') {
            $('#VATEntry').removeClass('hide');
            validateVat = true;
        } else {
            $('#VATEntry').addClass('hide');
            validateVat = false;
        }

        // Leitweg-ID (Pflicht) nur für öffentlicher Auftraggeber; E-Invoice-ID (optional) +
        // E-Mail-Rechnungsversand (Pflicht) nur für geschäftlich. Gegenseitig exklusiv.
        toggleRow('.js-leitwegid-row', '.input_LeitwegId', isPublicAuthority, true);
        validateLeitweg = isPublicAuthority;

        toggleRow('.js-einvoiceid-row', '.input_EInvoiceId', isGeschaeftlich, false);
        toggleRow('.js-einvoiceemail-row', '.input_EInvoiceEmail', isGeschaeftlich, true);
        validateEInvoiceEmail = isGeschaeftlich;
    }

    //Blendet wenn ein Land mit dem Eintrag "ShowVAT" ausgewählt wird das VAT-Feld ein
    $('.CountryListGeschaeftlich').on('change', function() {
        onFormChange();
    });

    //Blendet das Company-Feld ein wenn die Nutzung auf "Geschaeftlich"/"öffentlicher Auftraggeber" steht
    $('.usage-select').on('change', function() {
        onFormChange();
        var selected = $(this).val() as string;
        if (selected === 'business' || selected === 'publicauthority') {
            $('#Company').trigger('focus');
        }
    });

    // Server-gerenderte Auswahl (z.B. nach Validierungsfehler: business/publicauthority/private)
    // erhalten; preSelect nur auf einem frischen Formular ohne Auswahl anwenden.
    var currentUsage = ($('.usage-select')[0] as HTMLSelectElement).value;
    if (!currentUsage) {
        if ($('#Company').val() || $('#preSelect').val() === 'Geschäftlich') {
            $('.usage-select').val('business');
        } else if ($('#preSelect').val() === 'Privat') {
            $('.usage-select').val('private');
        }
    }
    onFormChange();
});
